"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
var Platform_1 = require("./Platform");
Object.defineProperty(exports, "Platform", { enumerable: true, get: function () { return Platform_1.Platform; } });
//# sourceMappingURL=index.js.map